<template>
  <div class="profile-page">
    <!-- 头部用户信息区 -->
    <div class="profile-header">
      <!-- 左侧头像 -->
      <div class="avatar-section">
        <div v-if="userInfo.avatar" class="user-avatar">
          <img :src="userInfo.avatar" alt="avatar" />
        </div>
        <div v-else class="user-avatar avatar-placeholder" :style="{ background: userInfo.avatarBg }"></div>
      </div>

      <!-- 右侧信息区 -->
      <div class="user-info">
        <!-- 用户名 -->
        <h2 class="user-name">🎀{{ userInfo.nickname }}🦄少女广播站</h2>

        <!-- 昵称IP直播间 -->
        <div class="user-meta-row">
          <span class="meta-label">昵称</span>
          <span class="meta-value">{{ userInfo.name }}</span>
          <span class="meta-dot">·</span>
          <span class="meta-label">IP</span>
          <span class="meta-value">{{ userInfo.ip }}</span>
          <span class="meta-dot">·</span>
          <span class="meta-label">直播间</span>
          <span class="meta-value">{{ userInfo.roomId }}</span>
        </div>

        <!-- 数据统计 -->
        <div class="user-stats">
          <div class="stat-item">
            <span class="stat-num">{{ userInfo.following }}</span>
            <span class="stat-label">关注</span>
          </div>
          <div class="stat-item">
            <span class="stat-num">{{ userInfo.followers }}</span>
            <span class="stat-label">粉丝</span>
          </div>
          <div class="stat-item">
            <span class="stat-num">{{ userInfo.likes }}</span>
            <span class="stat-label">赞</span>
          </div>
        </div>

        <!-- 操作按钮 -->
        <div class="action-btns">
          <button class="follow-btn" :class="{ followed: isFollowed }" @click="toggleFollow">
            {{ isFollowed ? '已关注' : '关注' }}
          </button>
          <button class="message-btn" @click="sendMessage">
            <i class="el-icon-chat-dot-round"></i>
          </button>
          <button class="more-btn" @click="showMore">
            <i class="el-icon-more"></i>
          </button>
        </div>

        <!-- 个人简介 -->
        <div class="user-bio">
          <p class="bio-line">
            <span class="bio-icon">🙋🏻‍♀️</span>
            <span>{{ userInfo.bio }}</span>
            <span class="bio-icon">🌻</span>
          </p>
          <p class="bio-line">
            <span class="bio-icon">⏰</span>
            <span>平日 {{ userInfo.liveTime }} 连线陪你喝下午茶</span>
            <span class="bio-icon">✨</span>
          </p>
          <p class="bio-line">
            <span class="bio-icon">😊</span>
            <span>想把所有温柔的琐碎，都讲给你听</span>
            <span class="bio-icon">☕</span>
          </p>
          <p class="bio-line">
            <span class="bio-icon">↓</span>
            <span>更多我的生活日常，都在下方链接里啦</span>
            <span class="bio-icon">↓</span>
          </p>
        </div>
      </div>
    </div>

    <!-- 导航标签页 -->
    <div class="profile-tabs">
      <div class="tabs-left"></div>
      <div class="tabs-right">
        <div
          v-for="(tab, index) in tabs"
          :key="index"
          class="tab-item"
          :class="{ active: activeTab === index }"
          @click="switchTab(index)"
        >
          {{ tab.name }}
          <i v-if="tab.icon" :class="tab.icon"></i>
        </div>
      </div>
    </div>

    <!-- 内容区域 -->
    <div class="profile-content">
      <!-- 作品 -->
      <div v-if="activeTab === 0" class="works-section">
        <div class="works-grid">
          <div v-for="(item, index) in worksList" :key="index" class="work-card" @click="playWork(item)">
            <div class="work-cover" :style="{ background: item.cover }">
              <span v-if="item.isLive" class="live-badge">直播</span>
              <span v-if="item.viewers" class="viewer-badge">
                <i class="el-icon-user"></i>{{ item.viewers }}
              </span>
            </div>
            <div class="work-info">
              <img :src="item.avatar" class="work-avatar" alt="avatar" />
              <span class="work-name">{{ item.name }}</span>
            </div>
          </div>
        </div>
      </div>

      <!-- 收藏 -->
      <div v-else-if="activeTab === 1" class="favorite-section">
        <div v-if="favoriteList.length > 0" class="works-grid">
          <div v-for="(item, index) in favoriteList" :key="index" class="work-card" @click="playWork(item)">
            <div class="work-cover" :style="{ background: item.cover }">
              <span v-if="item.isLive" class="live-badge">直播</span>
              <span v-if="item.viewers" class="viewer-badge">
                <i class="el-icon-user"></i>{{ item.viewers }}
              </span>
            </div>
            <div class="work-info">
              <img :src="item.avatar" class="work-avatar" alt="avatar" />
              <span class="work-name">{{ item.name }}</span>
            </div>
          </div>
        </div>
        <div v-else class="empty-state">
          <p>暂无收藏</p>
        </div>
      </div>

      <!-- 赞过 -->
      <div v-else-if="activeTab === 2" class="liked-section">
        <div v-if="likedList.length > 0" class="works-grid">
          <div v-for="(item, index) in likedList" :key="index" class="work-card" @click="playWork(item)">
            <div class="work-cover" :style="{ background: item.cover }">
              <span v-if="item.isLive" class="live-badge">直播</span>
              <span v-if="item.viewers" class="viewer-badge">
                <i class="el-icon-user"></i>{{ item.viewers }}
              </span>
            </div>
            <div class="work-info">
              <img :src="item.avatar" class="work-avatar" alt="avatar" />
              <span class="work-name">{{ item.name }}</span>
            </div>
          </div>
        </div>
        <div v-else class="empty-state">
          <p>暂无赞过的内容</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ProfileTr',
  data() {
    return {
      // 用户信息
      userInfo: {
        nickname: '宁宁的快乐捕捉计划',
        name: '宁宁',
        avatar: '',
        avatarBg: 'linear-gradient(135deg, #FF6B9D 0%, #C084FC 100%)',
        ip: '北京',
        roomId: '123456789',
        following: 5,
        followers: '4300',
        likes: '20.1k',
        bio: '这里有捕捉生活小确幸的可爱日常',
        liveTime: '13:00~15:00'
      },
      // 关注状态
      isFollowed: false,
      // 标签页
      tabs: [
        { name: '作品', id: 'works' },
        { name: '收藏', id: 'favorite', icon: 'el-icon-lock' },
        { name: '赞过', id: 'liked' }
      ],
      // 当前选中标签
      activeTab: 0,
      // 作品列表
      worksList: [
        { id: 1, name: '兔小兔', cover: 'linear-gradient(135deg, #FFB6C1 0%, #DDA0DD 100%)', avatar: 'https://via.placeholder.com/30', isLive: true, viewers: '233' },
        { id: 2, name: '兔小兔', cover: 'linear-gradient(135deg, #4A4A4A 0%, #2C2C2C 100%)', avatar: 'https://via.placeholder.com/30', isLive: false, viewers: '' },
        { id: 3, name: '兔小兔', cover: 'linear-gradient(135deg, #E0E0E0 0%, #B8B8B8 100%)', avatar: 'https://via.placeholder.com/30', isLive: false, viewers: '' },
        { id: 4, name: '兔小兔', cover: 'linear-gradient(135deg, #98D8C8 0%, #7FCDBB 100%)', avatar: 'https://via.placeholder.com/30', isLive: false, viewers: '' },
        { id: 5, name: '兔小兔', cover: 'linear-gradient(135deg, #8B0000 0%, #4A0000 100%)', avatar: 'https://via.placeholder.com/30', isLive: false, viewers: '' },
        { id: 6, name: '兔小兔', cover: 'linear-gradient(135deg, #FFD700 0%, #FFA500 100%)', avatar: 'https://via.placeholder.com/30', isLive: false, viewers: '' }
      ],
      // 收藏列表
      favoriteList: [],
      // 赞过列表
      likedList: []
    }
  },
  methods: {
    // 切换关注
    toggleFollow() {
      this.isFollowed = !this.isFollowed
    },
    // 发送消息
    sendMessage() {
      this.$emit('sendMessage')
    },
    // 显示更多
    showMore() {
      this.$emit('showMore')
    },
    // 切换标签
    switchTab(index) {
      this.activeTab = index
    },
    // 播放作品
    playWork(item) {
      this.$emit('playWork', item)
    }
  }
}
</script>

<style scoped lang="scss">
// 页面主容器
.profile-page {
  min-height: 100vh;
  background: #fff;
  padding: 40px 48px;
}

// 头部用户信息区
.profile-header {
  display: flex;
  align-items: flex-start;
  gap: 24px;
  margin-bottom: 32px;
}

// 头像区域
.avatar-section {
  flex-shrink: 0;
}

// 头像区域
.avatar-section {
  flex-shrink: 0;
}

.user-avatar {
  width: 120px;
  height: 120px;
  border-radius: 50%;
  object-fit: cover;
  border: 4px solid #fff;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.1);
}

// 用户信息区
.user-info {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

// 用户名
.user-name {
  font-size: 20px;
  font-weight: 600;
  color: #333;
  margin: 0;
}

// 元信息行
.user-meta-row {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 13px;
  color: #999;
}

.meta-label {
  color: #999;
}

.meta-value {
  color: #666;
}

.meta-dot {
  color: #ccc;
}

// 数据统计
.user-stats {
  display: flex;
  gap: 24px;
  margin-top: 4px;
}

.stat-item {
  display: flex;
  align-items: baseline;
  gap: 4px;
}

.stat-num {
  font-size: 16px;
  font-weight: 600;
  color: #333;
}

.stat-label {
  font-size: 13px;
  color: #666;
}

// 操作按钮
.action-btns {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-top: 8px;
}

.follow-btn {
  padding: 8px 24px;
  background: #8B5CF6;
  border: none;
  border-radius: 20px;
  font-size: 14px;
  color: #fff;
  cursor: pointer;
  transition: all 0.3s ease;

  &:hover {
    opacity: 0.9;
  }

  &.followed {
    background: #E5E7EB;
    color: #999;
  }
}

.message-btn,
.more-btn {
  width: 36px;
  height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #fff;
  border: 1px solid #E5E7EB;
  border-radius: 50%;
  color: #666;
  cursor: pointer;
  transition: all 0.3s ease;

  &:hover {
    background: #f5f5f5;
  }
}

// 个人简介
.user-bio {
  display: flex;
  flex-direction: column;
  gap: 4px;
  margin-top: 8px;
}

.bio-line {
  display: flex;
  align-items: center;
  gap: 4px;
  margin: 0;
  font-size: 13px;
  color: #666;
  line-height: 1.5;
}

.bio-icon {
  font-size: 14px;
}

// 导航标签页
.profile-tabs {
  display: flex;
  gap: 24px;
  margin-bottom: 24px;

  .tabs-left {
    width: 120px;
    flex-shrink: 0;
  }

  .tabs-right {
    display: flex;
    gap: 48px;
  }
}

.tab-item {
  font-size: 15px;
  color: #666;
  cursor: pointer;
  padding: 8px 0;
  position: relative;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  gap: 4px;

  i {
    font-size: 12px;
    color: #999;
  }

  &:hover {
    color: #8B5CF6;
  }

  &.active {
    color: #8B5CF6;
    font-weight: 500;

    &::after {
      content: '';
      position: absolute;
      bottom: 0;
      left: 0;
      width: 100%;
      height: 2px;
      background: #8B5CF6;
      border-radius: 1px;
    }
  }
}

// 内容区域
.profile-content {
  // 作品网格与头像垂直对齐
}

// 作品网格
.works-grid {
  display: grid;
  grid-template-columns: repeat(6, 1fr);
  gap: 16px;
  padding-left: 0;
}

.work-card {
  cursor: pointer;
  transition: transform 0.3s ease;

  &:hover {
    transform: translateY(-4px);
  }
}

.work-cover {
  position: relative;
  width: 100%;
  aspect-ratio: 3 / 4;
  background-size: cover;
  background-position: center;
  border-radius: 12px;
  overflow: hidden;
}

.live-badge {
  position: absolute;
  top: 8px;
  left: 8px;
  padding: 2px 8px;
  background: #FF6B9D;
  border-radius: 4px;
  font-size: 11px;
  color: #fff;
}

.viewer-badge {
  position: absolute;
  top: 8px;
  right: 8px;
  display: flex;
  align-items: center;
  gap: 2px;
  font-size: 11px;
  color: #fff;
  background: rgba(0, 0, 0, 0.4);
  padding: 2px 6px;
  border-radius: 8px;
}

.work-info {
  display: flex;
  align-items: center;
  gap: 6px;
  margin-top: 8px;
}

.work-avatar {
  width: 20px;
  height: 20px;
  border-radius: 50%;
}

.work-name {
  font-size: 12px;
  color: #333;
}

// 空状态
.empty-state {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 200px;
  color: #999;
  font-size: 14px;
}
</style>